export default {"src":"/_next/static/media/0x4bd17003473389a42daf6a0a729f6fdb328bbbd7.fc65eab5.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};